module.exports = __webpack_public_path__ + "components/flag/static/square/gy-3d53063f8aeea6904a63c9beeb3ccc52.svg";